import actionCreatorFactory from 'typescript-fsa';
import {
  Bill, BillListType, BillSortState, BillPrintInfoType,
} from '../../type/bill/bill.type';
import { apiBill } from './api/bill/api-bill';

const ActionCreator = actionCreatorFactory('bill');

export const BillActions = {
  api: {
    bill: apiBill,
  },
  setBill: ActionCreator<Bill | null>('set/bill'),
  setList: ActionCreator<BillListType[] | null>('set/list'),
  setSort: ActionCreator<BillSortState | null>('set/sort'),
  setPrintInfo: ActionCreator<BillPrintInfoType | null>('set/print'),
  resetState: ActionCreator('reset/state'),
};
